function FormInput (props) {

  return(
    <div style={{
        display: 'flex',
        justifyContent: 'center'
      }}>
      <input
        style={{
          width:'600px',
          height: '30px',
          padding: '10px',
          margin: '10px',
          border: 'none',
          borderRadius: '6px',
          background: '#fff',
          fontSize: '16px',
          fontFamily: 'Montserrat',
          fontWeight: '600',
        }}
        value={props.value}
        onChange={props.onChange}
        name={props.name}
        placeholder={props.placeholder}
        />
    </div>
  )
}

export default FormInput
